<template>
  <div class="detailContainer">
    <div class="detailContent">
      <van-form ref="form" :scroll-to-error="true">
        <van-cell-group>
          <van-field
            v-model="info.releaseNumber"
            label="放行号："
            placeholder="放行号"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 1">
          <van-field
            @click="handleShowReleaseType"
            required
            :rules="[{ required: true, message: '请选择物品类型' }]"
            v-model="info.itemType"
            label="物品类型："
            placeholder="请选择"
            label-width="100px"
          >
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="showReleaseType" position="bottom">
            <van-picker
              show-toolbar
              :columns="releaseTypeList"
              @confirm="confirmReleaseType"
              @cancel="cancelReleaseType"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="info.createrDepartment"
            label="部门："
            placeholder="部门"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="info.createrName"
            label="申请人："
            placeholder="申请人"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group>
          <div class="date_content">
            <van-field
              v-model="info.releaseDate"
              label="放行日期："
              placeholder="请输入选择放行日期"
              readonly
              @click="showTime"
              label-width="100px"
              :rules="[{ required: true, message: '请选择放行日期' }]"
            >
              <template #button>
                <!-- <i class="el-icon-caret-bottom"></i> -->
                <img
                  style="width: 16px; height: 14px; margin-right: 10px"
                  src="@/assets/mobVisitor/date.png"
                  alt=""
                />
              </template>
            </van-field>
          </div>
        </van-cell-group>
        <van-cell-group v-if="$route.query.type != 1">
          <van-field
            @click="handlePersonnelType"
            required
            :rules="[{ required: true, message: '请选择放行人员类型' }]"
            v-model="info.personnelType"
            label="放行人员类型："
            placeholder="请选择"
            label-width="110px"
            readonly
          >
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
          <van-popup v-model="showPersonnelType" position="bottom">
            <van-picker
              show-toolbar
              :columns="personnelTypeList"
              @confirm="confirmPersonnelType"
              @cancel="cancelPersonnelType"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 1">
          <div class="highlight_content">
            <van-field
              required
              v-model="info.carNumber"
              label="放行车辆："
              placeholder="请选择"
              label-width="100px"
              readonly
              @click="showSelectCar"
              :rules="[{ required: true, message: '请选择放行车辆' }]"
            />
          </div>
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 1">
          <van-field
            v-model="info.driverName"
            label="司机："
            placeholder="司机"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 1">
          <van-field
            v-model="info.visitorPhone"
            label="手机号码："
            placeholder="司机号码"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <!-- v-if="$route.query.show == 'true'"  v-if="$route.query.type == 2 || $route.query.type == 3"-->
        <van-cell-group>
          <div class="date_content1" v-if="info.personnelType == '内部员工'">
            <van-field
              required
              label="放行人员："
              placeholder="放行人员"
              v-model="driverInfo"
              label-width="100px"
              :rules="[{ required: true, message: '请输入放行人员' }]"
            >
              <template #input>
                <el-select
                  v-model="driverInfo"
                  placeholder="请输入员工姓名"
                  clearable
                  filterable
                  remote
                  :remote-method="changeOption"
                  :loading="loadingSelect"
                  ref="select"
                  @blur.native.capture="onblur"
                  @hook:mounted="cancalReadOnly"
                  @visible-change="cancalReadOnly"
                  @change="handleDriverInfo"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.empid"
                    :label="item.name + '/' + item.orgname"
                    :value="
                      item.name +
                      '/' +
                      item.workcode +
                      '/' +
                      item.orgname +
                      '/' +
                      item.mobile
                    "
                  >
                  </el-option>
                </el-select>
              </template>
            </van-field>
          </div>
          <div class="date_content" v-else>
            <van-field
              required
              :readonly="
                info.personnelType == '外部访客' || info.personnelType == ''
                  ? true
                  : false
              "
              v-model="driverInfo"
              label="放行人员："
              placeholder="请选择放行人员"
              label-width="100px"
              @click="showSelectCar"
              @input="releasePersonInput"
              :rules="[{ required: true, message: '请选择放行人员' }]"
            />
          </div>
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 2 || $route.query.type == 3">
          <van-field
            v-if="info.personnelType == '内部员工'"
            v-model="info.driverCode"
            label="工号："
            placeholder="工号"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 2 || $route.query.type == 3">
          <van-field
            v-if="info.personnelType == '内部员工'"
            v-model="info.department"
            label="放行人员部门："
            placeholder="放行人员部门"
            readonly
            label-width="100px"
          />
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 2 || $route.query.type == 3">
          <van-field
            v-if="info.personnelType == '内部员工'"
            v-model="info.visitorPhone"
            label="手机号："
            placeholder="手机号"
            readonly
            label-width="100px"
          />
          <div class="date_content" v-else>
            <van-field
              v-model="info.visitorPhone"
              :readonly="
                info.personnelType == '外部访客' || info.personnelType == ''
                  ? true
                  : false
              "
              required
              :rules="[
                { required: true, message: '请输入手机号' },
                phoneVerify
              ]"
              label="手机号："
              :placeholder="
                info.personnelType == '外部访客' || info.personnelType == ''
                  ? '手机号'
                  : '请输入手机号'
              "
              label-width="100px"
            />
          </div>
        </van-cell-group>
        <van-cell-group
          v-if="info.personnelType != '外部访客' && info.personnelType != ''"
        >
          <div class="date_content1">
            <van-field
              required
              label="园区："
              v-model="fieldParkId"
              placeholder="园区"
              label-width="100px"
              :rules="[{ required: true, message: '请输入园区' }]"
            >
              <template #input>
                <el-select
                  v-model="info.park"
                  placeholder="请选择园区"
                  clearable
                  ref="select1"
                  @blur.native.capture="onblur1"
                  @hook:mounted="cancalReadOnly1"
                  @visible-change="cancalReadOnly1"
                  style="width: 100%"
                  @change="changePark"
                >
                  <el-option
                    v-for="item in optionsParkId"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </template>
            </van-field>
          </div>
        </van-cell-group>
        <van-cell-group>
          <van-field
            @click="showVehicleType = true"
            v-model="info.vehicleTypeName"
            label="车辆类型："
            placeholder="请选择车辆类型"
            label-width="100px"
            readonly
          >
            <template #button>
              <van-icon name="arrow-down" />
            </template>
          </van-field>
        </van-cell-group>
        <van-cell-group v-if="$route.query.type == 2 || $route.query.type == 3">
          <div class="date_content">
            <van-field
              v-model="info.carNumber"
              label="车牌号码："
              placeholder="请输入车牌号码"
              label-width="100px"
            />
          </div>
        </van-cell-group>
        <van-cell-group>
          <van-field
            v-model="beforeImgList"
            label="拍照附件(选填)"
            readonly
            label-width="100px"
          >
            <template #input>
              <van-uploader
                v-model="beforeList"
                multiple
                :max-count="3"
                :after-read="improveBefore"
                @delete="removeBefore"
                :preview-full-image="false"
              />
            </template>
          </van-field>
        </van-cell-group>

        <van-cell-group>
          <div class="goods_con">
            <van-field
              required
              v-model="goodsList"
              label="放行物品："
              readonly
              label-width="100px"
              :rules="[{ required: true, message: '请输入放行物品' }]"
            >
              <template #input>
                <div class="table_content">
                  <div class="table_header">
                    <div class="left">物品名称</div>
                    <div class="right">数量</div>
                  </div>
                  <div
                    class="item_content"
                    v-for="(item, index) in info.goods"
                    :key="index"
                  >
                    <div class="item_left">
                      <van-field
                        v-model="item.goodsName"
                        placeholder="请输入物品名称"
                        @input="changeGoodsName"
                      />
                    </div>
                    <div class="item_right">
                      <van-field
                        type="number"
                        v-model="item.goodsNumber"
                        placeholder="请输入数量"
                        @input="changeGoodsName"
                      />
                    </div>
                  </div>
                  <div class="item_footer">
                    <img
                      @click="addGoodsList"
                      class="footer_img"
                      src="@/assets/mobVisitor/m3.png"
                      alt=""
                    />
                  </div>
                </div>
              </template>
            </van-field>
          </div>
        </van-cell-group>
        <van-cell-group>
          <div class="textareaCon">
            <van-field
              v-model="info.remark"
              rows="4"
              autosize
              label="备注："
              type="textarea"
              label-width="100px"
            />
          </div>
        </van-cell-group>
        <van-cell-group style="padding: 0 18px">
          <div class="flowPath">
            <div class="flowPathTitle">
              <span style="color: #ee0a24; font-size: 13px">*</span>
              携带的物品是否需送回公司：
            </div>
            <div class="radio_content">
              <van-field
                name="isMarried"
                :rules="[
                  {
                    required: true,
                    message: '请选择携带的物品是否需送回公司：'
                  }
                ]"
              >
                <template #input>
                  <van-radio-group
                    v-model="info.sendBack"
                    direction="horizontal"
                    @change="changeRadio"
                    :rules="[
                      {
                        required: true,
                        message: '请选择携带的物品是否需送回公司'
                      }
                    ]"
                  >
                    <van-radio name="0" style="margin-right: 40px"
                      >是
                      <template #icon="props">
                        <div class="circle" style="position: relative">
                          <div
                            :class="props.checked ? 'activeCircle' : ''"
                          ></div>
                          <img
                            v-if="props.checked"
                            style="width: 19px"
                            src="@/assets/mobVisitor/c1.png"
                            alt=""
                          />
                          <img
                            v-if="props.checked"
                            style="
                              width: 12px;
                              position: absolute;
                              left: 50.6%;
                              top: 43%;
                              transform: translate(-50%, -50%);
                            "
                            src="@/assets/mobVisitor/c2.png"
                            alt=""
                          />
                          <img
                            v-if="!props.checked"
                            style="width: 18px"
                            src="@/assets/mobVisitor/c3.png"
                            alt=""
                          />
                        </div>
                      </template>
                    </van-radio>
                    <van-radio name="1"
                      >否
                      <template #icon="props">
                        <div class="circle" style="position: relative">
                          <div
                            :class="props.checked ? 'activeCircle' : ''"
                          ></div>
                          <img
                            v-if="props.checked"
                            style="width: 19px"
                            src="@/assets/mobVisitor/c1.png"
                            alt=""
                          />
                          <img
                            v-if="props.checked"
                            style="
                              width: 12px;
                              position: absolute;
                              left: 50.6%;
                              top: 43%;
                              transform: translate(-50%, -50%);
                            "
                            src="@/assets/mobVisitor/c2.png"
                            alt=""
                          />
                          <img
                            v-if="!props.checked"
                            style="width: 18px"
                            src="@/assets/mobVisitor/c3.png"
                            alt=""
                          />
                        </div>
                      </template>
                    </van-radio>
                  </van-radio-group>
                </template>
              </van-field>
            </div>
          </div>
        </van-cell-group>
        <van-cell-group v-if="isShowPredictTime">
          <div class="date_content">
            <van-field
              required
              v-model="info.arriveDate"
              label="预计送回时间："
              placeholder="请选择预计送回时间"
              readonly
              @click="showPredictTime"
              label-width="110px"
              :rules="[
                { required: true, message: '请选择预计送回时间' },
                arriveDate()
              ]"
            >
              <template #button>
                <!-- <i class="el-icon-caret-bottom"></i> -->
                <img
                  style="width: 16px; height: 14px; margin-right: 10px"
                  src="@/assets/mobVisitor/date.png"
                  alt=""
                />
              </template>
            </van-field>
          </div>
        </van-cell-group>
      </van-form>
    </div>
    <div class="footer">
      <van-button class="cancel" @click="$router.go(-1)">取消</van-button>
      <van-button
        class="comfirm"
        @click="comfirmSubmit"
        v-loading="submitLoading"
        :disabled="submitLoading"
        >确认</van-button
      >
    </div>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="date"
        type="datetime"
        title="选择放行日期"
        :min-date="minDate"
        @confirm="comfirmTime"
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup v-model="showPredictDate" position="bottom">
      <van-datetime-picker
        v-model="predictDate"
        type="datetime"
        title="选择预计送回时间"
        :min-date="minDate"
        @confirm="comfirmPredictTime"
        @cancel="showPredictDate = false"
      />
    </van-popup>
    <van-popup v-model="showVehicleType" position="bottom">
      <van-picker
        title="车辆类型"
        show-toolbar
        :columns="columnsVehicleType"
        @confirm="onConfirmVehicleType"
        @cancel="showVehicleType = false"
      />
    </van-popup>
    <div class="popupSelect">
      <van-popup
        style="height: 400px"
        v-model="carInfo"
        position="bottom"
        closeable
        round
        @click-close-icon="handleCloseIcon"
      >
        <div class="car_conten">
          <van-field
            @input="changeKeyword"
            required
            :rules="[{ required: true, message: '请输入关键字' }]"
            v-model="keyword"
            placeholder="请输入关键字"
            label-width="110px"
            class="search"
          >
            <!-- <template #button>
              <van-icon name="search" />
            </template> -->
          </van-field>
          <div class="car_header">
            <div class="header_item">车牌号</div>
            <div class="header_item">姓名</div>
            <div class="header_item">手机</div>
          </div>
          <div class="item_list">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="item_content"
                v-for="(item, index) in carInfoList"
                :key="index"
                @click="activeCarInfo(item, index)"
                :class="activeIndex == index ? 'activeClass' : ''"
              >
                <div class="item_name">{{ item.carNumber }}</div>
                <div class="item_name">{{ item.driverName }}</div>
                <div class="item_name">{{ item.visitorPhone }}</div>
              </div>
            </van-list>
          </div>
        </div>
        <!-- <div class="footer">
          <van-button class="comfirm1" @click="comfirmCarInfo">确认</van-button>
        </div> -->
      </van-popup>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis";
import apis from "@/apis/insurance";
import apiss from "@/apis/medal";
import { getToken } from "@/utils/cookie";
import apiLogin from "@/apis";
export default {
  name: "carCostDetail",
  data() {
    return {
      info: {
        releaseNumber: "",
        createrDepartment: "",
        createrName: "",
        carNumber: "",
        releaseDate: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        driverName: "",
        visitorPhone: "",
        remark: "",
        goods: [
          {
            goodsName: "",
            goodsNumber: ""
          }
        ],
        sendBack: "1",
        arriveDate: moment(new Date()).format("YYYY-MM-DD HH:mm"),
        park: 8,
        itemType: "",
        personnelType: "",
        vehicleType: "",
        vehicleTypeName: "",
        wjsc: []
      },
      showReleaseType: false,
      showPersonnelType: false,
      fieldParkId: "8",
      driverInfo: "",
      date: "",
      showDate: false,
      minDate: new Date(),
      predictDate: "",
      showPredictDate: false,
      carInfo: false,
      carInfoList: [],
      page: 1,
      pageSize: 20,
      totalAll: 0,
      loading: false,
      finished: false,
      activeIndex: null,
      activeItem: {},
      isShowPredictTime: false,
      submitLoading: false,
      loadingSelect: false,
      options: [],
      optionsParkId: [],
      goodsList: "",
      keyword: "",
      releaseTypeList: ["原材料放行", "成品放行", "其他放行"],
      personnelTypeList: ["外部访客", "内部员工", "其他"],
      phoneVerify: {
        // 自定义校验规则
        validator: value => {
          console.log("value", value);
          return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57]|199)[0-9]{8}$/.test(
            value
          );
        },
        message: "请输入正确格式的手机号码",
        trigger: "onBlur"
      },
      beforeList: [],
      beforeImgList: "",
      fileIds: [],
      oAUploadInfo: {},
      showVehicleType: false,
      columnsVehicleType: [
        {
          value: 1,
          text: "货车"
        },
        {
          value: 2,
          text: "面包车"
        },
        {
          value: 3,
          text: "三轮车"
        }
      ]
    };
  },
  mounted() {
    this.getOptions();
    let token = getToken();
    if (token) {
      this.queryUsername(token);
    } else {
      this.$bus.$on("processToken", res => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          console.log(res);
        });
      });
    }
    this.queryReleaseNumbers();
  },
  methods: {
    //预计送回时间
    arriveDate() {
      const start = new Date(this.info.releaseDate).getTime();
      const end = new Date(this.info.arriveDate).getTime();
      return {
        validator: () => {
          return start < end;
        },
        message: "预计送回时间不能小于等于放行日期",
        trigger: "onChange"
      };
    },
    //获取token&用户信息
    getHrToken(username) {
      return new Promise(resolve => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }
          apiLogin.getUserToken({ username: thisname }).then(data => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            window.sessionStorage.empNo = info.empNo;
            resolve();
          });
          this.queryUsername(thisname);
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取创建用户信息
    queryUsername(token) {
      api
        .queryByUsername({
          username: token
        })
        .then(({ data }) => {
          this.info.createrDepartment = data.department;
          this.info.createrName = data.nickname;
          // this.info.createrUser = data.username;
        });
    },
    //关键词
    changeKeyword() {
      this.page = 1;
      this.queryReleaseCarList();
    },
    //搜索
    onLoad() {
      this.queryReleaseCarList();
    },
    //获取车辆信息
    queryReleaseCarList() {
      const parkIds = JSON.parse(sessionStorage.getItem("parkIds"));

      api
        .queryReleaseCarList({
          parkIdStr: parkIds,
          keyword: this.keyword || "",
          page: this.page,
          pageSize: this.pageSize
        })
        .then(res => {
          if (res.code == 200) {
            // this.carInfoList = res.data.list;
            this.totalAll = res.data.total;
            this.finished = false;
            if (this.page === 1) {
              this.carInfoList = res.data.list;
            } else {
              this.carInfoList = this.carInfoList.concat(res.data.list);
            }
            if (this.carInfoList.length < this.totalAll) {
              this.page = this.page + 1;
            } else {
              this.finished = true;
            }
            this.loading = false;
          }
        });
    },
    //获取放行号
    queryReleaseNumbers() {
      api.queryReleaseNumber().then(res => {
        if (res.code == 200) {
          this.info.releaseNumber = res.data;
        }
      });
    },
    //显示放行日期
    showTime() {
      this.showDate = true;
    },
    //确定放行日期
    comfirmTime(value) {
      this.info.releaseDate = moment(value).format("YYYY-MM-DD HH:mm");
      this.showDate = false;
    },
    //显示预计日期
    showPredictTime() {
      this.showPredictDate = true;
    },
    //确认预计日期
    comfirmPredictTime(value) {
      this.info.arriveDate = moment(value).format("YYYY-MM-DD HH:mm");
      this.showPredictDate = false;
    },
    //放行物品
    changeGoodsName() {
      this.$nextTick(() => {
        this.goodsList = 1;
        this.$refs.form.resetValidation("goodsList");
      });
    },
    // 新增放行物品
    addGoodsList() {
      this.info.goods.push({
        goodsName: "",
        goodsNumber: ""
      });
    },
    //显示 放行车辆
    showSelectCar() {
      if (
        this.info.personnelType == "外部访客" ||
        this.info.personnelType == ""
      ) {
        // this.queryReleaseCarList();
        this.carInfo = true;
      }
    },
    //放行人员输入框
    releasePersonInput() {
      this.info.carNumber = "";
      this.info.visitorPhone = "";
      this.activeItem = {};
      this.activeIndex = null;
    },
    //确认放行车辆
    comfirmCarInfo() {
      if (this.activeIndex) {
        this.carInfo = false;
        this.info.carNumber = this.activeItem.carNumber;
        this.info.driverName = this.activeItem.driverName;
        this.info.visitorPhone = this.activeItem.visitorPhone;
        this.info.id = this.activeItem.id;
        this.driverInfo = this.activeItem.driverName;
        this.info.park = null;
        this.fieldParkId = "";
      }
    },
    //关闭弹框
    handleCloseIcon() {
      this.activeItem = {};
      this.activeIndex = null;
      this.info.carNumber = "";
      this.info.visitorPhone = "";
      // this.driverInfo =''
    },
    // 选中车辆
    activeCarInfo(item, index) {
      this.activeItem = item;
      this.activeIndex = index;
      this.carInfo = false;
      this.info.carNumber = this.activeItem.carNumber;
      this.info.driverName = this.activeItem.driverName;
      this.info.visitorPhone = this.activeItem.visitorPhone;
      this.info.id = this.activeItem.id;
      this.driverInfo = this.activeItem.driverName;
      this.info.park = item.park;
      this.info.vehicleType = item.vehicleType;
      this.info.vehicleTypeName =
        item.vehicleType == 1
          ? "货车"
          : item.vehicleType == 2
          ? "面包车"
          : item.vehicleType == 3
          ? "三轮车"
          : "";
      if (item.fileIds) {
        const fileIds = item.fileIds.split(",");
        this.fileIds = fileIds;
        this.beforeList = fileIds.map(item => {
          return {
            url: apiss.imgUrl + item,
            isImage: true
          };
        });
      } else {
        this.beforeList = [];
        this.fileIds == [];
      }
      // this.fieldParkId = "";
    },
    //选择携带的物品是否需送回公司
    changeRadio(name) {
      console.log("name", name);
      this.isShowPredictTime = name == 1 ? false : true;
    },
    //选择物品类型
    handleShowReleaseType() {
      this.showReleaseType = true;
    },
    //选择物品类型
    confirmReleaseType(value) {
      this.info.itemType = value;
      this.showReleaseType = false;
    },
    //取消物品类型
    cancelReleaseType() {
      this.showReleaseType = false;
    },
    //选择人员类型
    handlePersonnelType() {
      this.showPersonnelType = true;
    },
    //选择人员类型
    confirmPersonnelType(value) {
      this.info.personnelType = value;
      this.showPersonnelType = false;
      this.info.driverName = "";
      this.info.visitorPhone = "";
      this.driverInfo = "";
      this.info.carNumber = "";
      this.activeItem = {};
      this.activeIndex = null;
      this.info.id = "";
      this.info.park = 8;
      this.info.wjsc = [];
      this.info.visitorFileList = [];
      this.fileIds = [];
      this.beforeList = [];
      this.info.vehicleType = null;
      this.info.vehicleTypeName = null;
    },
    //·取消人员类型
    cancelPersonnelType() {
      this.showPersonnelType = false;
    },
    //上传
    improveBefore(e) {
      e.status = "uploading";
      e.message = "上传中...";
      let formData = new FormData();
      if (e.length > 0) {
        e.forEach(item => {
          formData.append("file", item.file);
        });
      } else {
        formData.append("file", e.file);
      }
      apiss
        .uploadNew(formData)
        .then(res => {
          formData.append("empNo", getToken());
          console.log("formData", formData);
          apiss.oaUploadFileAPi(formData).then(data => {
            e.status = "";
            e.message = "";
            this.fileIds.push(res.data.id);
            console.log("data", data);
            const oAUploadInfo = {
              fileName: data.data.filename,
              filePath: "http://oa.nvc-lighting.com:8082" + data.data.loadlink,
              imageFileId:data.data.imagefileid
            };
            const oAUploadInfo1 = {
              fileId: res.data.id,
              fileName: data.data.filename,
              filePath: "http://oa.nvc-lighting.com:8082" + data.data.loadlink,
              imageFileId:data.data.imagefileid
            };
            this.info.wjsc.push(oAUploadInfo);
            this.info.visitorFileList.push(oAUploadInfo1);
            console.log("this.oAUploadInfo", this.oAUploadInfo);
            // filename loadlink
          });
        })
        .catch(() => {
          e.status = "";
          e.message = "";
        });
    },
    // 删除图片
    removeBefore(e, detail) {
      console.log("detail", detail);
      this.fileIds.splice(detail.index, 1);
    },
    // 添加放行条
    comfirmSubmit() {
      this.info.goods = this.info.goods.filter(
        item => item.goodsName && item.goodsNumber
      );
      console.log("this.info.goods", this.info.goods);
      if (this.info.goods.length > 0) {
        this.goodsList = 1;
      } else {
        this.goodsList = "";
      }
      if (this.info.sendBack == 1) {
        this.info.arriveDate = "";
      }
      this.$refs.form.validate().then(() => {
        this.submitLoading = true;
        if (this.$route.query.type != 1) {
          // this.info.driverCode = this.driverInfo.split("/")[1];
          this.info.driverName = this.driverInfo.split("/")[0];
          // delete this.info.itemType
        }
        if (this.$route.query.type == 1) {
          // delete this.info.personnelCode
          // delete this.info.department
          // delete this.info.personnelType
        }
        console.log("this.info666", this.info);
        const json = { ...this.info };
        json.fileIds = this.fileIds.toString();
        delete json.vehicleTypeName;
        api
          .addOrUpdateRelease({
            ...json,
            releaseType:
              this.$route.query.type == 1
                ? 1
                : this.$route.query.type == 2
                ? 2
                : this.$route.query.type == 3
                ? 3
                : null
          })
          .then(res => {
            if (res.code == 200) {
              this.$router.replace({
                path: "/releaseList"
              });
              this.$toast.success("申请成功");
            }
            this.submitLoading = false;
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
      // .catch(error => {
      //   // 校验失败，捕获错误信息
      //   error.forEach(item => {
      //     this.$refs.form.scrollToField(item.name);
      //     return;
      //   });
      // });
    },
    //输入员工姓名
    changeOption(value) {
      this.loadingSelect = true;
      apis
        .quaGetEmployeeInfo({
          name: value
        })
        .then(data => {
          this.options = data.data;
          this.loadingSelect = false;
        });
    },
    // 在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //改变员工姓名
    handleDriverInfo(value) {
      console.log(3434, value);
      this.info.driverCode = this.driverInfo.split("/")[1];
      this.info.department = this.driverInfo.split("/")[2];
      this.info.visitorPhone = this.driverInfo.split("/")[3];
    },
    // 在苹果手机上唤起键盘
    onblur1() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select1.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly1(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select1 } = this.$refs;
          const input = select1.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    //选择园区
    changePark(value) {
      this.fieldParkId = value;
    },
    //获取园区列表
    getOptions() {
      api.parkQueryAll({ type: 1 }).then(({ data }) => {
        this.optionsParkId = data;
      });
    },
    //确认车辆类型
    onConfirmVehicleType(value) {
      console.log(value);
      this.info.vehicleType = value.value;
      this.info.vehicleTypeName = value.text;
      this.showVehicleType = false;
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .detailContainer {
    width: 100%;
  }
  ::v-deep .van-popup {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .detailContainer {
    width: 276px * $zoom;
  }
  ::v-deep .van-popup {
    width: 276px * $zoom;
    left: initial;
  }
}
::v-deep .van-cell--required {
  &:before {
    content: "";
  }
  .van-cell__title.van-field__label {
    &:before {
      margin-right: 5px;
      color: #ee0a24;
      font-size: 22px;
      content: "*";
    }
  }
}
.search {
  border: 1px solid #999;
  border-radius: 5px;
}
.detailContainer {
  margin: auto;
  // background-color: #f3f3f5;

  background-color: #fff;
  .detailContent {
    padding-bottom: 12px * $zoom;
    overflow-y: auto;
    ::v-deep {
      .van-hairline--top-bottom::after,
      .van-hairline-unset--top-bottom::after {
        border: 0;
      }
      .van-cell::after {
        border-bottom: 0;
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
    .table_content {
      background-color: #fff;
      // padding: 0 11px * $zoom;
      width: 100%;
      .table_header {
        height: 26.5px * $zoom;
        border: 1px solid #dfdfdf;
        background: #f7f9fa;
        font-weight: bold;
        font-size: 9.5px * $zoom;
        color: #333333;
        display: flex;

        width: 100%;
        .left {
          width: 70%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
          border-right: 1px solid #dfdfdf;
        }
        .right {
          width: 30%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
        }
      }
      .item_content {
        height: 26.5px * $zoom;
        border: 1px solid #dfdfdf;
        border-top: 0;
        display: flex;
        .item_left {
          width: 70%;
          display: flex;
          justify-content: flex-start;
          align-content: center;
          flex-wrap: wrap;
          border-right: 1px solid #dfdfdf;
          padding-left: 10px * $zoom;
          ::v-deep {
            .van-cell {
              height: 100%;
            }
          }
        }
        .item_right {
          width: 30%;
          display: flex;
          justify-content: center;
          align-content: center;
          flex-wrap: wrap;
          ::v-deep {
            .van-cell {
              height: 100%;
            }
          }
        }
      }
      .item_footer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-content: center;
        flex-wrap: wrap;
        height: 26.5px * $zoom;
        border: 1px solid #dfdfdf;
        border-top: 0;
        .footer_img {
          width: 13.5px * $zoom;
          height: 13.5px * $zoom;
          margin-right: 30px * $zoom;
        }
      }
    }
    .textareaCon {
      ::v-deep {
        .van-field__label {
          padding: 5px * $zoom;
        }
        .van-cell {
          display: flex;
          flex-direction: column;
        }
        .van-field__body {
          border: 1px solid #c1c1c1;
          border-radius: 2px * $zoom;
        }
        .van-field__control {
          padding: 2px * $zoom 8px * $zoom;
        }
      }
    }
    .date_content {
      ::v-deep {
        .van-field__body {
          border: 1px solid #c1c1c1;
          border-radius: 2px * $zoom;
        }
        .van-field__control {
          padding: 2px * $zoom 8px * $zoom;
        }
      }
    }
    ::v-deep {
      .van-field--error .van-field__control,
      .van-field--error .van-field__control::placeholder {
        color: #c8cddb !important;
      }
    }
    .date_content1 {
      ::v-deep {
        .el-input--mini .el-input__inner {
          height: 55px;
          border-radius: 5px;
          border-color: #c1c1c1;
        }
      }
    }
    .goods_con {
      ::v-deep {
        .van-cell {
          display: flex;
          flex-direction: column;
        }
      }
    }
    .highlight_content {
      ::v-deep {
        .van-field__control::-webkit-input-placeholder {
          color: #048afb;
        }
      }
    }
    .flowPath {
      padding: 30px 0;

      .flowPathTitle {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        font-size: 9.5px * $zoom;
        color: #666666;
        margin-bottom: 20px;
      }
      .radio_content {
        ::v-deep {
          .van-radio__label {
            font-size: 10px * $zoom;
          }
        }
      }
    }
  }
  .footer {
    height: 48px * $zoom;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    justify-content: space-around;
    ::v-deep {
      .van-button {
        height: 22px * $zoom;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 32px;

        font-size: 10px * $zoom;
      }
    }
    .cancel {
      width: 61px * $zoom;
      border: 1px solid #388654;
      color: #388654;
    }
    .comfirm {
      width: 61px * $zoom;
      border: 1px solid #388654;
      color: #ffffff;
      background: #388654;
    }
    .comfirm1 {
      width: 81px * $zoom;
      border: 1px solid #388654;
      color: #ffffff;
      background: #388654;
    }
  }
  .car_conten {
    margin-top: 30px * $zoom;
    padding: 0 20px * $zoom;
    height: 200px * $zoom;
    // max-height: 300px* $zoom;
    .car_header {
      margin-top: 5px * $zoom;
      display: flex;
      align-content: center;
      justify-content: space-between;
      width: 100%;
      .header_item {
        width: 33%;
        display: flex;
        justify-content: center;
        font-weight: bold;
        font-size: 10px * $zoom;
        color: #282b32;
      }
    }
    .item_list {
      margin-top: 1px * $zoom;
      height: calc(100% - 95px);
      overflow-y: auto;
      &::-webkit-scrollbar {
        display: none;
      }
      .item_content {
        display: flex;
        align-content: center;
        justify-content: space-between;
        // margin-bottom: 20px * $zoom;
        padding: 30px 0;
        .item_name {
          width: 33%;
          display: flex;
          justify-content: center;
          font-weight: 400;
          font-size: 9.5px * $zoom;
          color: #969b9e;
          text-align: left;
          overflow: hidden; //超出文本隐藏

          white-space: nowrap; //不换行，只显示一行

          text-overflow: ellipsis; //超出部分省略号显示
        }
      }
      .activeClass {
        background: #f5f5f5;
        border-radius: 27px * $zoom;

        .item_name {
          color: #388654;
        }
      }
    }
  }
}
.popupSelect {
  ::v-deep {
    .van-overlay {
      background-color: initial;
    }
    .van-popup--bottom {
      box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.07);
    }
  }
}
</style>
